import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puz1 = () => {
    return (
        <div className='container'>
            <div class="text">
    <p><h2>How do we measure forty-five minutes using two identical wires, each of which takes an hour to burn? We have
        matchsticks with us. The wires burn non-uniformly. So, for example, the two halves of wire might burn in 10
        minutes and 50 minutes respectively<br/></h2></p>
    <p>&nbsp;<br/>&nbsp;<br/>&nbsp;</p>
    <p><strong>Answer:</strong><br/>If we light a stick, it takes 60 minutes to burn completely. What if we light the
        stick from both sides? It will take exactly half the original time, i.e. 30 minutes to burn completely.</p>
    <ol>
        <li><strong>0 minutes</strong> – Light stick 1 on both sides and stick 2 on one side.<br/></li>
        <li><strong>30 minutes</strong> – Stick 1 will be burnt out. Light the other end of stick 2.<br/></li>
        <li><strong>45 minutes</strong> – Stick 2 will be burnt out. Thus 45 minutes is completely measured.</li>
    </ol>
</div>
<NavLink to='/category/Puzzels/Puzzel2'>
<Button variant="contained" color="primary">Next page -&gt; </Button>
</NavLink>
        </div>
    )
}

export default Puz1
